<ion-card class="ion-no-margin" [class.loading]="loading">
  <empty-state
    *ngIf="empty"
    [showAction]="false"
    [showGraphic]="false"
    icon="people-circle"
    direction="row"
    description=""
  >
  </empty-state>

  <ng-container *ngIf="!empty">
    <ion-item
      [ngClass]="{
        'placement-card': true,
        'current-user': leaderboard.id === currentUser?.id
      }"
      (click)="fullView ? undefined : toggleInfo()"
    >
      <div class="ly-col flex" *ngIf="!loading">
        <ion-row *ngIf="fullView" class="flex">
          <div class="value-container">
            <h3 *ngIf="leaderboard.statistics">
              {{ $any(leaderboard.statistics)[valueToShow ? valueToShow : 'value'].current }}
            </h3>
          </div>
        </ion-row>

        <ion-row class="flex-no-wrap ion-align-items-center flex" *ngIf="!loading">
          <ion-text color="primary" *ngIf="index !== undefined">
            <p class="placement">
              <b>{{ index + 1 }}</b>
            </p>
          </ion-text>
          <entity-avatar [entity]="leaderboard.profile"> </entity-avatar>
          <ion-label class="ion-text-wrap">
            <ion-text color="primary" *ngIf="leaderboard.profile && leaderboard.profile.fullName">
              <h2>{{ leaderboard.profile.fullName }}</h2>
            </ion-text>
            <ion-text *ngIf="!fullView">
              <p
                class="flex-no-wrap ly-row ion-align-items-center"
                *ngIf="leaderboard.statistics && leaderboard.statistics.value"
              >
                <ion-icon
                  [name]="
                    leaderboard.statistics.value.indication === 'positive'
                      ? 'arrow-up'
                      : 'arrow-down'
                  "
                  class="dropdown-arrow"
                >
                </ion-icon>
                <span class="earned-value-change">
                  {{ leaderboard.statistics.value.change }}
                </span>

                &#183;

                <span class="earned-value"> {{ leaderboard.statistics.value.current }} EV </span>
                <span>
                  {{ leaderboard.badges.length }}
                  {{ 'achievementsText' | translate }}
                </span>
                <ion-icon
                  [name]="showMore ? 'caret-up-sharp' : 'caret-down-sharp'"
                  class="dropdown-arrow flex-none"
                >
                </ion-icon>
              </p>
            </ion-text>
          </ion-label>
        </ion-row>
      </div>

      <ng-container *ngIf="loading">
        <ion-text color="primary">
          <p class="placement">
            <ion-skeleton-text animated></ion-skeleton-text>
          </p>
        </ion-text>
        <ion-avatar>
          <ion-skeleton-text animated></ion-skeleton-text>
        </ion-avatar>

        <ion-label class="ion-text-wrap">
          <ion-text color="primary">
            <h2><ion-skeleton-text animated></ion-skeleton-text></h2>
          </ion-text>

          <ion-text color="secondary">
            <p><ion-skeleton-text animated></ion-skeleton-text></p>
            <p></p>
          </ion-text>
        </ion-label>
      </ng-container>
    </ion-item>

    <ng-container *ngIf="showMore">
      <div class="ly-col">
        <ion-row
          class="ion-align-items-center ion-margin"
          *ngIf="leaderboard.badges && leaderboard.badges.length"
        >
          <ion-icon
            *ngFor="let badge of leaderboard.badges"
            class="badge-icon"
            [tooltip]="badge.description"
            [hide-delay]="25"
            [options]="{ placement: 'bottom' }"
            [src]="
              'https://cdn.stable.netsocialapp.com/netsocial/badges/' + $any(badge).imageSvgSmall
            "
          >
          </ion-icon>
        </ion-row>

        <ion-row class="ion-justify-content-between ion-margin-horizontal stats ion-margin-bottom">
          <ion-row
            class="flex-no-wrap ion-align-items-center ion-justify-content-center"
            *ngFor="
              let key of [
                'accounts',
                'deliveries',
                'totalClicks',
                'impressions',
                'shares',
                'earnedValue',
                'likes'
              ]
            "
          >
            <ion-text
              *ngIf="leaderboard.statistics"
              color="primary"
              class="ion-margin-end stat-value"
            >
              <b>{{ $any(leaderboard.statistics)[key].current }}</b>
            </ion-text>
            <ion-text color="dark" class="text-ellipse">
              <b>{{ key + 'Text' | translate }}</b>
            </ion-text>
          </ion-row>
        </ion-row>
      </div>
    </ng-container>
  </ng-container>
</ion-card>
